/*
    * changes from version 4 to version 5:
           1- integrals :

               changes:
                 1. originFrom => originalFrom
                 2. originTo => originalTo

                paths:
                  - integral

           2- ranges :

                changes:
                  1. originFrom => originalFrom
                  2. originTo => originalTo
                  3. originDelta => originalDelta
                  4. originX => originalX

                paths:
                  - range
                  - range > x
                  - range > y
                  - range > signals > signal
                  - range > signals > peaks > peak

            3- zones :

                changes:
                  1. originDelta => originalDelta
                  2. originX => originalX
                  3. originY => originalY
                  4. originZ => originalZ

                paths:
                  - zone > signals > singal > x
                  - zone > signals > singal > y
                  - zone > signals > singal > peaks > peak

*/
import { changeKeys } from './changeKeys';
export default function migrateToVersion5(input) {
    if (input?.version === 5)
        return input;
    const migratedData = { ...input, version: 5 };
    const changedKeys = {
        originFrom: 'originalFrom',
        originTo: 'originalTo',
        originDelta: 'originalDelta',
        originX: 'originalX',
        originY: 'originalY',
        originZ: 'originalZ',
    };
    for (const spectrum of migratedData?.data?.spectra || []) {
        for (const key of ['peaks', 'ranges', 'zones']) {
            if (spectrum?.[key]) {
                spectrum[key] = changeKeys(spectrum[key], changedKeys);
            }
        }
    }
    return migratedData;
}
//# sourceMappingURL=migrateToVersion5.js.map